import React from 'react'
//
import Form from "./Form";
import AppContext from "../../../context/AppContext";

class Create extends React.Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.state = false
    }

    componentDidMount() {
        /** @type {AppBase} */
        let $app = this.context;
        $app.record.getRecordDefaultOptions((r) => this.setState({res: r}))
    }

    render = () => <Form caller={this}/>

}

export default Create;